<div class="content-header">
    <div class="content-top"></div>
    <div class="wrapper-reponsive">
        <nav class="navbar header-nav p-0">
            <div class="navbar-left">
                <a [routerLink]="['/']" class="navbar-brand" (click)="touchMenu = false">
                    <img src="../../../../assets/img/logo.png" alt="">
                </a>
                <span class="name-htorg" [title]="HTOrgName">{{HTOrgName}}</span>
            </div>
            <div class="navbar-right">
                <div class="navbar-menu" [ngClass]="{'active': touchMenu}">
                    <ul>
                        <li>
                            <a *ngIf="isLogin" [routerLink]="['/toppage']" (click)="touchMenu = false">{{'STR_TOPPAGE' | translate}}</a>
                        </li>
                        <li>
                            <a *ngIf="isLogin" [routerLink]="['/src-personal-inf']" (click)="touchMenu = false">{{'STR_USER_INFO_MANAGE' | translate}}</a>
                        </li>
                        <li class="pr-0">
                            <button *ngIf="isLogin" class="btn btn-user" (click)="logout()">{{'STR_BTN_LOGOUT' |translate}}</button>
                        </li>
                    </ul>
                </div>
                <!-- Temporarily hide multi-language function -->
                <!-- <div class="language">
                    <nav class="navbar p-0" aria-label="Dropdown Language">
                        <div class="dropdown">
                            <button class="btn btn-language dropdown-toggle" type="button" id="dropdownLanguageButton"
                                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" (click)="touchMenu = false">
                                <img class="img-language" src="assets/img/icon-{{languageUse}}.png" alt="">
                            </button>
                            <ul class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownLanguageButton">
                                <a class="dropdown-item no-active-menu" [ngClass]="{'active': languageUse == 'ja'}"
                                    (click)="switchLanguage('ja')"><img class="img-language"
                                        src="assets/img/icon-ja.png" alt=""> 日本語</a>
                                <a class="dropdown-item no-active-menu" [ngClass]="{'active': languageUse == 'en' }"
                                    (click)="switchLanguage('en')"><img class="img-language"
                                        src="assets/img/icon-en.png" alt=""> English</a>
                                <a class="dropdown-item no-active-menu" [ngClass]="{'active': languageUse == 'vi' }"
                                    (click)="switchLanguage('vi')"><img class="img-language"
                                        src="assets/img/icon-vi.png" alt=""> Tiếng Việt</a>
                            </ul>
                        </div>
                    </nav>
                </div> -->
                <button class="btn-toggle-menu" [ngClass]="{'active': touchMenu}" (click)="touchMenu = !touchMenu" *ngIf="isLogin">
                    <span></span>
                    <span></span>
                    <span></span>
                </button>
            </div>
        </nav>
    </div>
</div>